<template>
    <div class="upperPanel">
            <b-button v-show="!newRecord" class="addButton" v-on:click="add()">{{addButton}}</b-button>
            <div class="searchInput">
                <b-input-group>
                    <b-input-group-prepend is-text>
                        <b-icon icon="search" variant="primary"></b-icon>
                    </b-input-group-prepend>
                    <b-input type="search" :placeholder="placeholder" name="searchBar" v-model="searchData" v-on:keyup="$emit('searched-data', searchData)"></b-input>
                </b-input-group>
            </div>
        </div>
</template>

<script>
export default {
    name: 'UpperBar',
    methods: {
        add: function(){
            this.$emit('add');
        },
    },
    props: ["newRecord", "addButton", "placeholder"],
    data: function(){
        return {
            searchData: '',
        }
    }
}
</script>

<style lang="scss" scoped>
.upperPanel {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    align-items: center;
    width: 90%;
    margin: 0 auto;
    .addButton {
    background-color: green;
    margin: 10px;
    }
    .icon {
        background-color: blue;
    }
}
</style>